import React from "react";
import Image, { StackWrapper } from "./style";
import data from "../../../../common/assets/data/home";

const StackImage = ({ className, Imgsrc }) => {
  const data = Imgsrc;
  const addAllClasses = [" "];
  if (className) {
    addAllClasses.push(className);
  }
  return (
    <StackWrapper>
      <Image className={addAllClasses.join(" ")} src={data.img} alt=""></Image>
      <Image className={addAllClasses.join(" ")} src={data.img} alt=""></Image>
      <Image className={addAllClasses.join(" ")} src={data.img} alt=""></Image>
    </StackWrapper>
  );
};

export default StackImage;
